import { render, staticRenderFns } from "./table-actions.vue?vue&type=template&id=5b703082&scoped=true"
import script from "./table-actions.vue?vue&type=script&lang=ts"
export * from "./table-actions.vue?vue&type=script&lang=ts"
import style0 from "./table-actions.vue?vue&type=style&index=0&id=5b703082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b703082",
  null
  
)

export default component.exports